module.exports = __webpack_public_path__ + "img/example.d26d02f7.svg";